// extracted by mini-css-extract-plugin
export default {"logo":"App_logo__-M9IF","sider":"App_sider__7kbxb","cityTaxiLogo":"App_cityTaxiLogo__H2Svp"};